<template>
  <TeamMembers />
</template>

<script>
import TeamMembers from "./TeamMembers.vue";

export default {
  name: "Messages",
  components: { TeamMembers },
};
</script>
